import { ETableSound } from '../types/enums'
import { useAudio } from '.'

export const useTableSound = (props: { volume: number }) => {
  const winAudio = useAudio({
    src: '/audio/wood-surface-multi-coin-payout.mp3',
    volume: props.volume,
  })
  const cardDropAudio = useAudio({
    src: '/audio/card_drop.mp3',
    volume: props.volume,
  })
  const betAudio = useAudio({
    src: '/audio/poker-chip-drop.mp3',
    volume: props.volume,
  })
  const raiseAudio = useAudio({
    src: '/audio/handfull-of-poker-chips.mp3',
    volume: props.volume,
  })
  const allInAudio = useAudio({
    src: '/audio/allin-push-chips.mp3',
    volume: props.volume,
  })
  const callAudio = useAudio({
    src: '/audio/handfull-of-poker-chips.mp3',
    volume: props.volume,
  })
  const foldAudio = useAudio({
    src: '/audio/throwing-cards-on-table.mp3',
    volume: props.volume,
  })
  const checkAudio = useAudio({
    src: '/audio/double-tap.mp3',
    volume: props.volume,
  })
  const usersTurnAudio = useAudio({
    src: '/audio/glass_knock.mp3',
    volume: props.volume,
  })

  const audioHookBySound: Partial<
    Record<ETableSound, ReturnType<typeof useAudio>>
  > = {
    [ETableSound.WIN]: winAudio,
    [ETableSound.BET]: betAudio,
    [ETableSound.RAISE]: raiseAudio,
    [ETableSound.ALL_IN]: allInAudio,
    [ETableSound.CALL]: callAudio,
    [ETableSound.FOLD]: foldAudio,
    [ETableSound.CHECK]: checkAudio,
    [ETableSound.CARD_DROP]: cardDropAudio,
    [ETableSound.USERS_TURN]: usersTurnAudio,
  }

  const play = async (sound: ETableSound) => {
    const audio = audioHookBySound[sound]
    if (!audio) {
      console.warn(`There is no audio for «${sound}».`)
      return
    }
    await audio.play()
  }

  return {
    play,
  }
}
